import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.lucky_wheel.timeout,
    (timeout) => {
        return {
            timeout
        }
    }
)